export const BlockQuotation = 'blockquote';
